enum WarehouseParameterFormatEnum {
    Dollars = 'DOLLARS',
    Months = 'MONTHS',
    Percentage = 'PERCENTAGE',
}

export default WarehouseParameterFormatEnum;
